import React, { useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
// @ts-ignore CSS is loaded by the application bundler.
import "ag-grid-community/styles/ag-grid.css";
import SearchBar from "../../SearchBarTable/SearchBarTable";
// @ts-ignore CSS is loaded by the application bundler.
import "ag-grid-community/styles/ag-theme-alpine.css";
// @ts-ignore CSS is loaded by the application bundler.
import "../AgGridTheme.css";
import SortHeader from "../SortingHeader";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
} from "ag-grid-community";
import { FaArrowUp, FaIndustry, FaUser, FaKey, FaCogs } from "react-icons/fa";
// import CustomFloatingFilter from "../EntitlementsSetup/CustomFloatingFilter";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
]);

interface ResourceTableProps {
  resources: any[];
  onDeleteResource: (resourceName: string) => void;
  onEditResource: (resourceName: string) => void;
  onRowSelect: (resource: any) => void;
  onClearSelection: () => void;
  selectedRow: string | null;
}

const ResourceTable: React.FC<ResourceTableProps> = ({
  resources,
  onRowSelect,
  selectedRow,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [gridApi, setGridApi] = useState<any>(null);

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };
  const filteredResources = useMemo(() => {
    const lowerSearchQuery = searchQuery.toLowerCase();
    return resources.filter(group =>
      group.iso_code?.toLowerCase().includes(lowerSearchQuery) ||
      group.asset_name?.toLowerCase().includes(lowerSearchQuery) ||
      group.resource_type_code?.toLowerCase().includes(lowerSearchQuery) ||
      group.betm_object_name?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.betm_object_id?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.resource_status_code?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.participant_name?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.betm_object_name?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.iso_resource_name?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.iso_resource_id?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.iso_price_node_name?.toString().toLowerCase().includes(lowerSearchQuery) ||
      group.iso_price_node_id?.toString().toLowerCase().includes(lowerSearchQuery)

    );
  }, [resources, searchQuery]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Asset",
        field: "asset_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Asset',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Resource Staus Code",
        field: "resource_status_code",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Resource Staus Code',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Participant",
        field: "participant_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Participant',
          enableSorting: true,
          icon: <FaUser className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "ISO",
        field: "iso_code",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO',
          enableSorting: true,
          icon: <FaIndustry className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Resource Type",
        field: "resource_type_code",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Resource Type',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "ISO Resource Name",
        field: "iso_resource_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO Resource Name',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },  
      {
        headerName: "Ancillary Node",
        field: "region",
        sortable: true,
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {/* {params.value || "—"} */}
            {           params.value === null || params.value === undefined ? "null" : params.value}
          </div>
       
        ),
        headerComponent: SortHeader,
        headerComponentParams: {
          displayName: "Ancillary Node",
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />,
        },
        headerClass:
          "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer",
      },
        
      {
        headerName: "ISO Resource ID",
        field: "iso_resource_id",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO Resource ID',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      }, 
      {
        headerName: "ISO Price Node Name",
        field: "iso_price_node_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO Price Node Name',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },  
      {
        headerName: "ISO Price Node ID",
        field: "iso_price_node_id",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO Price Node ID',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      }, 
      
      {
        headerName: "BETM Object Name",
        field: "betm_object_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'BETM Object Name',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },  
      {
        headerName: "BETM Object Key",
        field: "betm_object_id",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'BETM Object Key',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      }, 
    ],
    []
  );

  const defaultColDef = useMemo(() => ({
    // sortable: true,
    // filter: true,
    // floatingFilter: true,
    resizable: true,
    cellStyle: {
      padding: "8px 12px",
      fontSize: "16px",
      fontFamily: "'Poppins', sans-serif",
      color: "#374151",
    },
  }), []);

  return (
    <div className="p-4 bg-white shadow-md rounded-xl font-poppins">
      {/* <div className="flex justify-between items-center mb-4">
        <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full w-full max-w-md">
          <FaSearch className="mr-2 text-gray-600" />
          <input
            type="text"
            placeholder="Search assets..."
            className="bg-transparent outline-none w-full"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
      </div> */}
      {/* <div className="flex justify-between items-center space-x-4 mb-4"> */}
      <div className="flex justify-between items-center mb-4">
           <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full  max-w-md">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          placeholder="Search resources..."
        />
      </div>
      </div>
      <div
        className="ag-theme-alpine font-poppins text-base text-gray-700"
        style={{ height: "var(--admin-tab-grid-height, max(475px, calc(100dvh - 320px)))", width: "100%", overflow: 'auto', border: '1px solid #E7E4FF', borderRadius: '8px' }}
      >
        <AgGridReact
          theme="legacy"
          rowData={filteredResources}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
         domLayout="normal"
          rowHeight={60}
          headerHeight={55}
          // floatingFiltersHeight={55}
          pagination={true}
          paginationPageSize={50}
          // rowGroupPanelShow="always"
          // groupDisplayType="multipleColumns"
          className="ag-theme-alpine"
          suppressRowHoverHighlight={false}
          // columnHoverHighlight={true}
          onGridReady={(params) => setGridApi(params.api)}
          onRowClicked={(event) => onRowSelect(event.data)}
          getRowClass={(params) =>
            params.data.resource_type_code === selectedRow ? "ag-row-selected-custom" : ""
          }
        />
      </div>

          </div>
  );
};

export default ResourceTable;
